import { api } from "../lib/api";

// Modules activés
export const getFeatures = () =>
  api.get("/tenant/features").then((response) => response.data);

// Branding
export const getBranding = () => api.get("/tenant/branding").then((r) => r.data);

export const updateBranding = (payload) =>
  api.put("/tenant/branding", payload).then((r) => r.data);

export const uploadLogo = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/tenant/branding/logo", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// Scoring config
export const getScoring = () =>
  api.get("/tenant/scoring-config").then((r) => r.data);

export const updateScoring = (payload) =>
  api.put("/tenant/scoring-config", payload).then((r) => r.data);

export const previewScoring = (payload) =>
  api.post("/tenant/scoring-config/preview", payload).then((r) => r.data);
